/* eslint @typescript-eslint/explicit-function-return-type: off */

export const getAuthenticityToken = () => {
  const csrfParam = document.querySelector('meta[name=csrf-param]').content;
  const csrfToken = document.querySelector('meta[name=csrf-token]').content;
  return { [csrfParam]: csrfToken };
};
